export default __webpack_public_path__ + "static/media/Track.fb2b039e.png";